export default function (initialDataInteractor, workspaceId, workspaceName, memberIds) {
  let workspaceToUpdate = {};

  initialDataInteractor.data.workspaces.forEach(function (workspace) {
    if (workspace.id == workspaceId) {
      workspaceToUpdate = workspace;
    }
  });

  workspaceToUpdate.name = workspaceName;
  workspaceToUpdate.people = memberIds;

  // console.log(initialDataInteractor);
}